(function () {
	const slideshow = () => {
		document.querySelectorAll(".slideshow").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);
			const autoplay = block.data("autoplay");
			const stopAutoplay = block.data("stop-autoplay");
			const delay = block.data("delay") * 1000;
			const speed = block.data("speed") * 1000;
			const effect = block.data("effect");			
	
			let swiperParams = {
				speed: speed,
				keyboard: true,
				loop: true
			};
	
			let autoplayParams = autoplay ? {
				autoplay: {
					delay: delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: stopAutoplay,
				},
			} : {};

			let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
			let swiperTextElement = document.querySelector(swiperTextSelector);
	
			const swiperText = new Swiper(swiperTextSelector, {
				...swiperParams,
				//autoplay: false,
				spaceBetween: 24,
				direction: "horizontal",
				slidesPerView: "auto",
				//slideToClickedSlide: true,
				//loopedSlides: 4,
				allowTouchMove: false,

				breakpoints: {
					990: {
						allowTouchMove: true,
					},
					1600: {
						allowTouchMove: false,
						touchRatio: 0,
						keyboard: {
							enabled: false,
						},
					},
				},
				on: {
					init: function () {
						swiperTextElement.classList.add('first_step');
					},
					slideChange: function () {
						swiperTextElement.classList.remove('first_step');
					}
				}
			});

			let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
			let swiperImgElement = document.querySelector(swiperImgSelector);

			// The tabs row is `display: none` below 990 (section-slideshow.css:170, and its
			// .swiper-wrapper additionally gets `transform: none !important` at <=989), so on
			// mobile the thumbs Swiper exists but has zero size and cannot translate. Binding
			// the content Swiper's `thumbs` to a zero-size thumbs instance breaks the pair:
			// swiping the content had no thumb to sync to, so slides did not advance and the
			// pagination bullets rendered but never tracked — the reported mobile fault.
			// Only wire thumbs up when the tabs row is actually laid out, and re-evaluate on
			// resize so crossing the breakpoint restores/releases the link.
			const tabsVisible = () =>
				!!(swiperTextElement && swiperTextElement.getClientRects().length);

			const thumbsParams = tabsVisible() ? { thumbs: { swiper: swiperText } } : {};

			const swiperImg = new Swiper(swiperImgSelector, {
					pagination: {
						el: `#${id} .swiper-pagination`,
						clickable: true,
					},
					...swiperParams,
					...autoplayParams,
					effect: effect,
					...thumbsParams,
				on: {
					init: function () {
						swiperImgElement.classList.add('first_step');
						box.style.setProperty('--bullet-duration', `${delay}ms`);
					},
					slideChange: function () {
						box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
					},
					slideChangeTransitionEnd: function () {
						swiperImgElement.classList.remove('first_step');
					}
				}
			});

			// Attach/detach the thumbs link as the tabs row appears and disappears across the
			// 990 breakpoint, so a desktop->mobile resize does not leave the content Swiper
			// bound to a zero-size thumbs instance (and vice versa).
			let thumbsLinked = tabsVisible();
			const syncThumbs = () => {
				if (swiperImg.destroyed) return;
				const visible = tabsVisible();
				if (visible === thumbsLinked) return;
				thumbsLinked = visible;

				if (visible) {
					swiperImg.thumbs.swiper = swiperText;
					swiperImg.thumbs.init();
					swiperImg.thumbs.update(true);
				} else if (swiperImg.thumbs) {
					swiperImg.thumbs.swiper = null;
				}
			};

			let resizeTimer;
			window.addEventListener("resize", () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(syncThumbs, 150);
			});

			if (autoplay && stopAutoplay) {
				swiperImgElement.addEventListener("mouseenter", function () {
						swiperTextElement.classList.add("stop_move");
					});
					swiperImgElement.addEventListener("mouseleave", function () {
						swiperTextElement.classList.remove("stop_move");
					});
			}

			if($(block.find(".slideshow__content")).length === 1) {
				swiperImgElement.classList.add('no_slideshow');
				swiperTextElement.classList.add('no_slideshow');

				swiperImg.destroy(true, true);
				swiperText.destroy(true, true);
			}
		})
	}


	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();